import { Payment } from './types';

export function createPayment(
	factoryEnergyArr = [],
	batteryEnergyArr = [],
	carbonReserve = 0
): Payment {
	return {
		factoryEnergyArr,
		batteryEnergyArr,
		carbonReserve,
	};
}
